import { fetchEntities } from "../common/genericTable/service.genericTable";
import { useCommon } from "../composition-functions/common";
import { NaturaType } from "../invoice/model.invoiceContent";
import { VatSettingDto, VatSettingInputDto } from "./dto.vatSetting";
import { vatSettingGenericTable } from "./genericTable.vatSetting";

export async function getVatSettings(mandantId: number) {
  return fetchEntities({
    path: vatSettingGenericTable.getPath(mandantId),
    query: {},
    schema: vatSettingGenericTable.schema,
  });
}

type GetVatSettingParams = {
  vatSettingId: string;
  mandantId: number;
};
export async function getVatSetting({ vatSettingId, mandantId }: GetVatSettingParams): Promise<VatSettingDto> {
  const { getRequest } = useCommon();

  const response = await getRequest({ path: `/admin/mandants/${mandantId}/vatSettings/${vatSettingId}` });
  const result = await response.json();
  return result;
}

interface CreateOrUpdateVatSettingParams {
  mandantId: number;
  vatSettingInputDto: VatSettingInputDto;
}
export async function createOrUpdateVatSetting({
  mandantId,
  vatSettingInputDto,
}: CreateOrUpdateVatSettingParams): Promise<VatSettingDto> {
  const { postRequest } = useCommon();

  const response = await postRequest({
    path: `/admin/mandants/${mandantId}/vatSettings/`,
    data: JSON.stringify(vatSettingInputDto),
  });
  const result = await response.json();
  return result;
}

interface DeleteVatSettingParams {
  mandantId: number;
  vatSettingId: number;
}

export async function deleteVatSetting({ mandantId, vatSettingId }: DeleteVatSettingParams) {
  const { deleteRequest } = useCommon();
  await deleteRequest({ path: `/admin/mandants/${mandantId}/vatSettings/${vatSettingId}` });
}

export const SUPPORTED_VAT_SETTING_NATURA_VALUES = [NaturaType.N1, NaturaType.N21, NaturaType.N22] as const;

export type SupportedVatSettingNatura = (typeof SUPPORTED_VAT_SETTING_NATURA_VALUES)[number];

const SUPPORT_SET = new Set<NaturaType>(SUPPORTED_VAT_SETTING_NATURA_VALUES);

export function isSupportedVatSettingNatura(natura: NaturaType): natura is SupportedVatSettingNatura {
  return SUPPORT_SET.has(natura);
}
